import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Row, Col, Container, Form } from 'react-bootstrap'
import { useEffectAfterMount } from '../../utils/hooks'

export enum Temperature {
  NOT_SELECTED = 0,
  IN_RANGE = 1,
  OUT_OF_RANGE = 2
}

export interface RecordTemperatureProps {
  temperature: number
  required: boolean
  disabled?: boolean
  validate?: boolean | undefined
  onChange: (value: number, isValid: boolean) => void
}

const RecordTemperature = (props: RecordTemperatureProps) => {
  const [isValid, setIsValid] = useState(true)
  const [temperature, setTemperature] = useState(props.temperature)

  const refObj = useRef({ onChange: props.onChange })
  const refInput = useRef<HTMLInputElement | null>(null)

  const isRangeSelected = useCallback(() => {
    return !props.required || temperature !== Temperature.NOT_SELECTED
  }, [props.required, temperature])

  useEffectAfterMount(() => {
    if (props.validate !== undefined) {
      const valid = isRangeSelected()
      if (!valid) { refInput.current?.focus() }

      setIsValid(valid)
    }

  }, [isRangeSelected, props.validate])

  useEffect(() => {
    refObj.current.onChange(temperature, isRangeSelected())
  }, [isRangeSelected, temperature])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setTemperature(Number(e.target.value))

  return (
    <Container fluid className='mt-3'>
      <Row>
        <Col><h6 className={`mb-0 ${props.required ? 'required' : ''}`}>Record Temperature</h6></Col>
        <Col>
          <Form.Check inline name="record-temp" type="radio"
            ref={refInput}
            id="temp_in_range"
            label="Temp In Range"
            value={Temperature.IN_RANGE}
            className="abc-radio text-success"
            checked={temperature === Temperature.IN_RANGE}
            disabled={props.disabled}
            onChange={onChange} />
        </Col>
        <Col>
          <Form.Check inline name="record-temp" type="radio"
            id="temp_out_of_range"
            label="Temp Out of Range"
            value={Temperature.OUT_OF_RANGE}
            className="abc-radio text-danger"
            checked={temperature === Temperature.OUT_OF_RANGE}
            disabled={props.disabled}
            onChange={onChange} />
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          {!isValid && <Form.Control.Feedback type="invalid" className="d-block">Please select temperature range.</Form.Control.Feedback>}
        </Col>
      </Row>
    </Container>)
}

export default RecordTemperature
